module.exports = __webpack_public_path__ + "static/clock_calendar-1e4bd2b4f1be1f512c06aa6fbf877261.gif";